import { ContentType } from '@smart-tv/typings/content';

export const encodeProgramSheetParams = (
  sid?: number,
  eventId?: number,
  contentId?: number,
  contentType?: ContentType,
  subProviderId?: string,
  universeId?: string,
  provider?: string
) => {
  const params = new URLSearchParams();
  if (sid) params.set('sid', sid.toString());
  if (eventId) params.set('eid', eventId.toString());
  if (contentId) params.set('cid', contentId.toString());
  if (contentType) params.set('ctype', contentType);
  if (subProviderId) params.set('spid', subProviderId);
  if (universeId) params.set('uid', universeId);
  if (provider) params.set('prov', provider);
  return params.toString();
};

export default encodeProgramSheetParams;
